import React, { createContext, useState, useEffect, useContext } from 'react';

const DeviceContext = createContext();

export function useDevice() {
    return useContext(DeviceContext);
}

export function DeviceProvider({ children }) {
    const [isMobile, setIsMobile] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Function to check if the device is mobile based on screen width
    const checkIfMobile = () => {
        const width = window.innerWidth;
        setWindowWidth(width);
        setIsMobile(width < 768); // Standard Bootstrap breakpoint for mobile
    };

    useEffect(() => {
        // Initial check
        checkIfMobile();

        // Add event listener for window resize
        window.addEventListener('resize', checkIfMobile);

        // Clean up the event listener on unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    // Context value with mobile state and window width
    const value = {
        isMobile,
        windowWidth,
        // Additional device info can be added here if needed in the future
        isTablet: windowWidth >= 768 && windowWidth < 992,
        isDesktop: windowWidth >= 992
    };

    return (
        <DeviceContext.Provider value={value}>
            {children}
        </DeviceContext.Provider>
    );
}